import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2964abc9&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ny5dev1b/rgirap/thgit/web.app/fxquotes/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2964abc9')) {
      api.createRecord('2964abc9', component.options)
    } else {
      api.reload('2964abc9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2964abc9&lang=pug&", function () {
      api.rerender('2964abc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/index.vue"
export default component.exports